export default __webpack_public_path__ + "static/media/pcr-vs-rapid.55d112d0.svg";